<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->

	<label>Bus Number:</label>
	<label class="InfoText">{{ BusNbr }}</label>

	<label>Bus Description:</label>
	<label class="InfoText">{{ BusDesc }}</label>

	<label>Route Type:</label>
	<select [disabled]="Imported == true" class="form-control" name="BusRouteTypeID" [(ngModel)]="BusRouteTypeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstBusRouteType" [ngValue]="o.BusRouteTypeID">
			{{ o.BusRouteTypeDesc }}
		</option>
	</select>

	<label>Number:</label>
	<input [disabled]="Imported == true" class="form-control" type="text" placeholder="Bus Route Number" [(ngModel)]="BusRouteNbr" />

	<label>Description:</label>
	<input class="form-control" type="text" placeholder="Bus Route Name/Description" [(ngModel)]="BusRouteDesc" />

	<label>Comments 1:</label>
	<textarea class="form-control" [(ngModel)]="BusRouteMisc1" rows="5"></textarea>

	<label>Comments 2:</label>
	<textarea class="form-control TextArea" [(ngModel)]="BusRouteMisc2" rows="5"></textarea>

	<label>Auto-Allow Guest Riders</label>
	<input type="checkbox" class="form-control" [(ngModel)]="isAllowGuestRider" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button *ngIf="EditMode == false" [disabled]="Imported == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button *ngIf="EditMode == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
